import { useState } from 'react';

import { QuestionDuplicateCheckEndpoint } from '@core/types/types.endpoint.question';
import { Accordion, AccordionItem } from '@frontend/components/ui/accordion';
import { Button } from '@frontend/components/ui/button';
import { SearchInput } from '@frontend/Search/Input/SearchInput';
import { Question } from '@frontend/shared/components/Question/Question';
import { useApi } from '@frontend/shared/hooks/shared.hook.useApi';
import { useBroadcaster } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { useSingleSearchParam } from '@frontend/shared/hooks/useSingleSearchParam';

export function DuplicatePage() {
  const [q, setQ] = useSingleSearchParam('q');
  const [value, onChange] = useState(q);

  const { data, loading, error, setData } =
    useApi<QuestionDuplicateCheckEndpoint>(
      '/question/duplicateCheck',
      {
        query: q,
      },
      !!q,
    );

  // Listen for question updates
  useBroadcaster((e) => {
    if (e.event === 'question:delete' && data) {
      setData(data.filter((q) => e.questionId !== q.id));
    }
    if (e.event === 'question:save' && data) {
      setData(data.map((q) => (q.id === e.question.id ? e.question : q)));
    }
  });

  let heading = '';
  if (data) {
    heading = data.length
      ? `${data.length} Potential duplicate${data.length === 1 ? '' : 's'}`
      : '✅   No potential duplicates...';
  }
  if (error) {
    heading = 'Error checking for duplicates :(';
  }
  if (loading) {
    heading = 'Checking for duplicates...';
  }

  return (
    <>
      <SearchInput
        placeholder="Check for duplicates…"
        onSearch={setQ}
        value={value}
        onChange={onChange}
        searchVal={q}
      />
      {heading && <h2 className="text-lg font-semibold mt-10">{heading}</h2>}
      {!loading && !!data?.length && (
        <>
          <Accordion type="single" collapsible className="mb-4 mt-4">
            {data.map((q) => (
              <AccordionItem
                key={q.id}
                value={q.id}
                className="border-none mt-1.5"
                data-id={q.id}
              >
                <Question question={q} isExpanded={false} />
              </AccordionItem>
            ))}
          </Accordion>
        </>
      )}
      {!loading && (
        <div className="flex justify-center mt-12">
          <Button asChild>
            <a href="slack://">Back to Slack</a>
          </Button>
        </div>
      )}
    </>
  );
}
